<template>
    <form @submit.prevent="handleSubmit">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ title }}</p>
            </header>
            <section class="modal-card-body is-flex">
                <div class="media">
                    <div class="media-left">
                        <span class="icon has-text-danger is-large"><i class="fa fa-exclamation-circle fa-3x"></i></span>
                    </div>
                    <div class="media-content">
                        <p>{{ message }}</p>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <div v-for="(button, index) in buttons" :key="button.text">
                    <button v-if="!button.options" class="button" :class="{ 'is-primary' : (index == buttons.length - 1) }" @click="handleClick(index)">{{ button.text }}</button>
                    <o-dropdown aria-role="list" v-else>
                        <button class="button" :class="{ 'is-primary' : index == buttons.length - 1 }" slot="trigger" slot-scope="{ active }">
                            <span>{{ button.text }}</span>
                            <o-icon icon="angle-down"></o-icon>
                        </button>
                        <o-dropdown-item v-for="(item, idx) in button.options" :key="item" aria-role="listitem" @click="handleClick(index, idx)">{{ item }}</o-dropdown-item>
                    </o-dropdown>
                </div>
            </footer>
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        mixins: [],

        components: {
        },

        props: {
            title: {
                type: String
            },
            message: {
                type: String
            },
            buttons: {
                type: Array
            }
        },

        mounted() {

        },

        data () {
            return {

            }
        },

        methods: {
            ...mapActions([]),
            handleClick(button, item) {
                this.$emit('modalButtonClick', { button, item })
                this.$parent.$parent.$emit('update:active', false)
            },
            handleSubmit() {
                return false
            }
        },

        computed: {
            ...mapGetters([])
        }
    }
</script>
<style scoped>
    .modal-card-foot {
        justify-content: flex-end;
    }

    .modal-card-foot button {
        margin: 0px 2px;
        min-width: 80px;
        justify-content: center;
    }

    .modal .modal-card {
        max-width: 460px;
        width: auto;
    }
    .modal .modal-card .modal-card-head {
        font-size: 1.25rem;
        font-weight: 600;
    }
</style>
